// src/App.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { useEffect } from "react";
import { setupIdleLogout } from "../src/utils/idleLogout";
import { isAuthenticated } from "../src/utils/auth";
import Login from './pages/Login/Login';
import ForgotPassword from './pages/Login/ForgotPassword';
import Dashboard from './pages/Dashboard/Dashboard';
import Register from './pages/Signup/Register';
import ManageUsers from './pages/Signup/ManageUsers';
import Retailclients from './pages/Client/Retail/RetailClients';
import Retailaddpolicy from './pages/Policy/AddPolicy/RetailAddPolicy';
import DraftPolicies from './pages/Policy/DraftPolicies/DraftPolicies';
import ConvertedCorporatePolicy from './pages/ConvertedPolicy/Corporate/convertedCorporatePolicy';
import ConvertedRetailPolicy from './pages/ConvertedPolicy/Retail/convertedRetailPolicy';
import RetailClientList from './pages/Mastering/ClientMastering/RetailClientData';
import CorporateClientList from './pages/Mastering/ClientMastering/CorporateClientData';
import InsurerMaster from './pages/Mastering/Product Master/InsurerMaster/insurerMaster';
import InsurerBranchMaster from './pages/Mastering/Product Master/InsurerMaster/insurerBranchMaster';
import PolicyMaster from './pages/Mastering/Product Master/PolicyMaster/policyMaster';
import ClassofPolicyMaster from './pages/Mastering/Product Master/PolicyMaster/ClassofPolicyMaster';
import CategoryMaster from './pages/Mastering/Product Master/PolicyMaster/CategoryMaster';
import AddPOS from './pages/Pos/AddPOS';
import ViewPOS from './pages/Pos/posList';
import POSList from './pages/Pos/ClientPOSPage'
import GeoLocation from './pages/GeoLocation/GeoLocation';
import LocationList from "./pages/GeoLocation/LocationList";
import PrivateRoute from './components/PrivateRoute';
import PremiumRegisterRetail from './pages/Reports/premiumRegister';
import BusinessStatements from './pages/Reports/BusinessStatements';
import IrdaiReportsRetail from './pages/Reports/irdaiReports';
import InvoiceReportsRetail from './pages/Finance/invoiceReports';
import CommissionLedger from './pages/Finance/CommissionLedger';
import DailySummary from './pages/Reports/dailySummary';
import CorporateClient from './pages/Client/Corporate/CorporateClients';
import Endorsement from './pages/Manage Policy/Endorsement';
import Claims from './pages/Manage Policy/Claims';
import Renewals from './pages/Manage Policy/Renewals';
import RetailPolicyProspect from './pages/Client/Retail/RetailPolicyProspect';
import RetailProspectManage from './pages/Client/prospects/RetailProspectManage';
import CorporateProspectManage from './pages/Client/prospects/CorporateProspectManage';
import PrivilegeManager from './pages/Admin/PrivilegeManager';
import Roles from './pages/Admin/Roles';
import AssistantKnowledge from './pages/Admin/AssistantKnowledge';
import AuditLogs from './pages/Admin/AuditLogs';
import NotificationHistory from './pages/Notifications/NotificationHistory';
import RequirePrivilege from "./components/RequirePrivilege";
import AIAssistant from "./components/AIAssistant/AIAssistant";
import {
  MANAGE_POLICY_PRIVILEGES,
  claimAccessPrivileges,
  endorsementAccessPrivileges
} from "./utils/managePolicyPrivileges";
import {
  CLIENT_MANAGEMENT_PRIVILEGES,
  corporateClientAccessPrivileges,
  retailClientAccessPrivileges
} from "./utils/clientManagementPrivileges";
import {
  EMPLOYEE_MANAGEMENT_PRIVILEGES
} from "./utils/employeeManagementPrivileges";
import { PRODUCT_MASTER_PRIVILEGES } from "./utils/productMasterPrivileges";
import { POLICY_TRANSACTION_PRIVILEGES } from "./utils/policyTransactionPrivileges";


const App = () => {
  useEffect(() => {
    if (isAuthenticated()) {
      setupIdleLogout();
    }
  }, []);

  return (
    <Router>
      {/* <Header />
      <Sidebar /> */}
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route
          path="/register"
          element={
            <RequirePrivilege anyOf={[EMPLOYEE_MANAGEMENT_PRIVILEGES.userCreation.create]}>
              <Register />
            </RequirePrivilege>
          }
        />
        <Route
          path="/users/manage"
          element={
            <RequirePrivilege anyOf={EMPLOYEE_MANAGEMENT_PRIVILEGES.users.access}>
              <ManageUsers />
            </RequirePrivilege>
          }
        />
        {/* Use PrivateRoute to protect Dashboard */}
        <Route path="/admin/privileges" element={<PrivateRoute element={<PrivilegeManager />} anyOf={["privilege.manage"]} />} />
        <Route path="/admin/assistant-knowledge" element={<PrivateRoute element={<AssistantKnowledge />} anyOf={["privilege.manage"]} />} />
        <Route
          path="/admin/audit-logs"
          element={
            <RequirePrivilege anyOf={["systemSettings.auditLogs"]}>
              <AuditLogs />
            </RequirePrivilege>
          }
        />
        <Route
          path="/admin/roles"
          element={
            <RequirePrivilege anyOf={EMPLOYEE_MANAGEMENT_PRIVILEGES.roles.access}>
              <Roles />
            </RequirePrivilege>
          }
        />
        <Route path="/dashboard" element={<PrivateRoute element={<Dashboard />} allowedRoles={["user", "admin"]} />} />
        <Route path="/notifications" element={<PrivateRoute element={<NotificationHistory />} allowedRoles={["user", "admin"]} />} />
        <Route
          path="/retail/clients-form"
          element={
            <RequirePrivilege anyOf={[CLIENT_MANAGEMENT_PRIVILEGES.retail.add]}>
              <Retailclients />
            </RequirePrivilege>
          }
        />
        <Route
          path="/corporate/clients-form"
          element={
            <RequirePrivilege anyOf={[CLIENT_MANAGEMENT_PRIVILEGES.corporate.add]}>
              <CorporateClient />
            </RequirePrivilege>
          }
        />
        <Route path="/prospect/retail-prospect" element={<PrivateRoute element={<RetailPolicyProspect />} allowedRoles={["admin", "user"]} />} />
        {/* <Route path="/prospect/retail-prospect-manage" element={<PrivateRoute element={<RetailProspectManage />} allowedRoles={["admin"]} />} /> */}
        <Route
          path="/prospect/retail-prospect-manage"
          element={
            <RequirePrivilege
              // allowedRoles={["admin"]}
              anyOf={[
                "manageProspects.retail.active.view",
                "manageProspects.retail.lost.view"
              ]}
            >
              <RetailProspectManage />
            </RequirePrivilege>
          }
        />
        <Route
          path="/prospect/corporate-prospect-manage"
          element={
            <RequirePrivilege
              // allowedRoles={["admin"]}
              anyOf={[
                "manageProspects.corporate.active.view",
                "manageProspects.corporate.lost.view"
              ]}
            >
              <CorporateProspectManage />
            </RequirePrivilege>
          }
        />
        <Route
          path="/add-policy"
          element={
            <RequirePrivilege anyOf={[POLICY_TRANSACTION_PRIVILEGES.addPolicy.access]}>
              <Retailaddpolicy />
            </RequirePrivilege>
          }
        />
        <Route
          path="/draft-policies"
          element={
            <RequirePrivilege anyOf={[POLICY_TRANSACTION_PRIVILEGES.draftPolicies.access]}>
              <DraftPolicies />
            </RequirePrivilege>
          }
        />
        <Route
          path="/retail/client-list"
          element={
            <RequirePrivilege anyOf={retailClientAccessPrivileges}>
              <RetailClientList />
            </RequirePrivilege>
          }
        />
        <Route
          path="/corporate/client-list"
          element={
            <RequirePrivilege anyOf={corporateClientAccessPrivileges}>
              <CorporateClientList />
            </RequirePrivilege>
          }
        />
        <Route
          path="/retail/converted-policy"
          element={
            <RequirePrivilege
              // allowedRoles={["admin"]}
              anyOf={[
                "transactions.convertedPolicies.retail.view"
              ]}
            >
              <ConvertedRetailPolicy />
            </RequirePrivilege>
          }
        />
        <Route
          path="/corporate/converted-policy"
          element={
            <RequirePrivilege
              // allowedRoles={["admin"]}
              anyOf={[
                "transactions.convertedPolicies.corporate.view"
              ]}
            >
              <ConvertedCorporatePolicy />
            </RequirePrivilege>
          }
        />

        <Route
          path="/endorsements/add"
          element={
            <RequirePrivilege anyOf={endorsementAccessPrivileges}>
              <Endorsement />
            </RequirePrivilege>
          }
        />
        <Route
          path="/claims"
          element={
            <RequirePrivilege anyOf={claimAccessPrivileges}>
              <Claims />
            </RequirePrivilege>
          }
        />
        <Route
          path="/renewals"
          element={
            <RequirePrivilege anyOf={[MANAGE_POLICY_PRIVILEGES.renewals.process]}>
              <Renewals />
            </RequirePrivilege>
          }
        />

        <Route
          path="/retail/reports/premium-register"
          element={
            <RequirePrivilege anyOf={["reports.premiumRegister"]}>
              <PremiumRegisterRetail />
            </RequirePrivilege>
          }
        />

        <Route
          path="/reports/business-statements"
          element={
            <RequirePrivilege anyOf={["reports.businessStatements"]}>
              <BusinessStatements />
            </RequirePrivilege>
          }
        />

        <Route
          path="/retail/reports/irdai-reports"
          element={
            <RequirePrivilege anyOf={["reports.irdiaReports"]}>
              <IrdaiReportsRetail />
            </RequirePrivilege>
          }
        />

        <Route
          path="/finance/manage-invoices"
          element={
            <RequirePrivilege anyOf={["finance.invoiceManagement"]}>
              <InvoiceReportsRetail />
            </RequirePrivilege>
          }
        />

        <Route
          path="/finance/commission-ledger"
          element={
            <RequirePrivilege anyOf={["finance.commissionManagement"]}>
              <CommissionLedger />
            </RequirePrivilege>
          }
        />

        <Route
          path="/reports/daily-summary"
          element={
            <RequirePrivilege anyOf={["reports.dailySummary"]}>
              <DailySummary />
            </RequirePrivilege>
          }
        />


        <Route
          path="/insurer-master"
          element={
            <RequirePrivilege anyOf={PRODUCT_MASTER_PRIVILEGES.insurer.access}>
              <InsurerMaster />
            </RequirePrivilege>
          }
        />

        <Route
          path="/insurer-branch-master"
          element={
            <RequirePrivilege anyOf={PRODUCT_MASTER_PRIVILEGES.branch.access}>
              <InsurerBranchMaster />
            </RequirePrivilege>
          }
        />

        <Route
          path="/policy-master"
          element={
            <RequirePrivilege anyOf={PRODUCT_MASTER_PRIVILEGES.policy.access}>
              <PolicyMaster />
            </RequirePrivilege>
          }
        />

        <Route
          path="/class-of-policy-master"
          element={
            <RequirePrivilege anyOf={PRODUCT_MASTER_PRIVILEGES.classOfPolicy.access}>
              <ClassofPolicyMaster />
            </RequirePrivilege>
          }
        />

        <Route
          path="/category-master"
          element={
            <RequirePrivilege anyOf={PRODUCT_MASTER_PRIVILEGES.category.access}>
              <CategoryMaster />
            </RequirePrivilege>
          }
        />

        <Route path="/geo-location" element={<PrivateRoute element={<GeoLocation />} allowedRoles={["user", "admin"]} />} />
        <Route path="/add-pos" element={<PrivateRoute element={<AddPOS />} allowedRoles={["admin"]} />} />
        <Route path="/view-pos" element={<PrivateRoute element={<ViewPOS />} allowedRoles={["admin"]} />} />
        <Route path="/pos-list" element={<PrivateRoute element={<POSList />} allowedRoles={["admin"]} />} />
        <Route path="/location-list" element={<PrivateRoute element={<LocationList />} allowedRoles={["admin"]} />} />

        {/* Unauthorized Page for Restricted Access */}
        <Route path="/unauthorized" element={<h2>Unauthorized - Access Denied</h2>} />
      </Routes>
      <AIAssistant />
    </Router>
  );
};

export default App;
